import { render, staticRenderFns } from "./curtainDialog.vue?vue&type=template&id=81fe480a&"
import script from "./curtainDialog.vue?vue&type=script&lang=js&"
export * from "./curtainDialog.vue?vue&type=script&lang=js&"
import style0 from "./curtainDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports